// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujRegistre.js
//  la barre de sélection, le tableau des sujets, la pagination
//
//  Sorti de SujPanel.js le 7 aout 2026. Le JSX est celui d'origine,
//  deplace au caractere pres ; les props sont calculees par analyse
//  de portee, pas devinees.
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { SujRow } from "./SujRow";

export function SujRegistre({ LIMIT, allSelected, bulk, busyId, data, forcerTache, isMobile, loading, page, selected, setPage, setSelected, setStatutSujet, token, totalPages }) {
  return (
    <>
      {/* Barre de sélection */}
      {selected.length > 0 && (
        <div style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, borderRadius: 8, padding: "8px 14px", display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
          <span style={{ color: THEME.accent, fontSize: 12, fontWeight: 700 }}>{selected.length} sélectionné(s)</span>
          <button onClick={() => bulk("resolu")} style={{ background: THEME.emeraldDim, border: `1px solid ${THEME.emerald}`, color: THEME.emerald, borderRadius: 6, padding: "5px 12px", cursor: "pointer", fontSize: 12, fontWeight: 700 }}>✓ Résoudre</button>
          <button onClick={() => bulk("ignore")} style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, color: THEME.textMuted, borderRadius: 6, padding: "5px 12px", cursor: "pointer", fontSize: 12, fontWeight: 700 }}>✕ Ignorer</button>
          <button onClick={() => bulk("ouvert")} style={{ background: THEME.amberDim, border: `1px solid ${THEME.amber}`, color: THEME.amber, borderRadius: 6, padding: "5px 12px", cursor: "pointer", fontSize: 12, fontWeight: 700 }}>↺ Réouvrir</button>
          <button onClick={() => setSelected([])} style={{ marginLeft: "auto", background: "transparent", border: "none", color: THEME.textMuted, cursor: "pointer", fontSize: 12 }}>Désélectionner</button>
        </div>
      )}

      {/* Registre */}
      <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 12, overflow: "hidden" }}>
        {!isMobile && (
          <div style={{ display: "grid", gridTemplateColumns: "28px 40px 1fr 110px 70px 100px 108px", gap: 8, padding: "10px 14px", borderBottom: `1px solid ${THEME.border}`, color: THEME.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase" }}>
            <input type="checkbox" checked={!!allSelected}
              onChange={() => setSelected(allSelected ? [] : (data ? data.sujets.map((i) => i.id) : []))} />
            <div style={{ textAlign: "center" }}>Cat.</div>
            <div>Titre</div>
            <div>Sévérité</div>
            <div style={{ textAlign: "right" }}>Occ.</div>
            <div>Dernière vue</div>
            <div style={{ textAlign: "right" }}>Actions</div>
          </div>
        )}
        {loading && <div style={{ color: THEME.textMuted, fontSize: 13, padding: 20 }}>Chargement…</div>}
        {!loading && data && data.sujets.length === 0 && (
          <div style={{ color: THEME.textDim, fontSize: 13, padding: 30, textAlign: "center" }}>Aucun sujet ne correspond à ces filtres.</div>
        )}
        {!loading && data && data.sujets.map((suj) => (
          <SujRow key={suj.id} sujet={suj} token={token} isMobile={isMobile}
            selected={selected.includes(suj.id)}
            onToggleSelect={() => setSelected((prev) => prev.includes(suj.id) ? prev.filter((x) => x !== suj.id) : [...prev, suj.id])}
            onStatut={(s) => setStatutSujet(suj.id, s)}
            onTask={forcerTache}
            busy={busyId === suj.id} />
        ))}
      </div>

      {/* Pagination */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span style={{ color: THEME.textMuted, fontSize: 12 }}>{data ? data.total : 0} sujet(s) · page {page + 1}/{Math.max(1, totalPages)}</span>
        <div style={{ display: "flex", gap: 6, marginLeft: "auto" }}>
          <button onClick={() => setPage(Math.max(0, page - 1))} disabled={page === 0}
            style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, color: page === 0 ? THEME.textDim : THEME.text, borderRadius: 6, padding: "6px 14px", cursor: page === 0 ? "not-allowed" : "pointer", fontSize: 12 }}>← Préc.</button>
          <button onClick={() => setPage(page + 1)} disabled={!data || (page + 1) * LIMIT >= data.total}
            style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, color: !data || (page + 1) * LIMIT >= data.total ? THEME.textDim : THEME.text, borderRadius: 6, padding: "6px 14px", cursor: !data || (page + 1) * LIMIT >= data.total ? "not-allowed" : "pointer", fontSize: 12 }}>Suiv. →</button>
        </div>
      </div>
    </>
  );
}
